import { combineReducers, configureStore } from '@reduxjs/toolkit';
import callSlice from './callSlice';
import digitalSlice from './digitalSlice';
import toolbarReducer from './toolbarSlice';
import dashboardReducer from './dashboardSlice';
import timerReducer from './timerSlice';
import { authUser } from '../services/agent.service';
import { isLoginDataPresent } from '../services/util';

const ozToolBarReducers = combineReducers({
  toolbar: toolbarReducer,
  digital: digitalSlice,
  call: callSlice,
  dashboard: dashboardReducer,
  timer: timerReducer
});

export const rootReducer = (state, action) => {
  if (action.type === "Clear") {
    state = undefined;
  }
  return ozToolBarReducers(state, action);
};

const loadState = () => {
  try {
    const currentReduxStates = localStorage.getItem('state');
    if (currentReduxStates === null) {
      return undefined;
    }
    return JSON.parse(currentReduxStates);
  } catch (e) {
    console.log("error loadin redux state from local storage", e)
  }
};

const saveState = (state) => {
  if (!authUser()) return;
  try {

    let currentReduxStates = JSON.stringify(state);
    if (!isLoginDataPresent('saveState')) {
      currentReduxStates = localStorage.getItem('state');
    }
    localStorage.setItem('state', currentReduxStates);
  } catch (e) {
    console.log("Error saving redux state before reload", e)
  }
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: loadState(),
  devTools: process.env.NODE_ENV !== 'production',
});


store.subscribe(() => {
  let closeTab = store.getState().toolbar.closeTab
  if (!closeTab) {
    saveState(store.getState())
  }
})
window.addEventListener('beforeunload', () => {
  let closeTab = store.getState().toolbar.closeTab
  if (!closeTab) {
    saveState(store.getState());
  }
});

window.removeEventListener('beforeunload', () => {
  saveState(store.getState());
});